import { useMatches } from 'react-router-dom';

type MatchWithBreadcrumb = ReturnType<typeof useMatches>[number] & {
  handle: {
    breadcrumb: (match: ReturnType<typeof useMatches>[number]) => React.ReactNode;
  };
};

export default function Breadcrumbs() {
  const matches = useMatches() as MatchWithBreadcrumb[];
  const parent = [...matches].reverse().find((match) => match.handle?.breadcrumb);

  if (!parent) return null;

  return (
    <nav id="breadcrumb-navigation" aria-label="Breadcrumb">
      <span className="flex items-center gap-1 text-sm text-primary">
        <span aria-hidden="true">←</span>
        {parent.handle.breadcrumb(parent)}
      </span>
    </nav>
  );
}
